import React from "react";
import { RouteObject } from "react-router-dom";
import { RouteTimedShuttleMapBuilder } from "./ui/route-timed-shuttle-map-builder";

export function getRouteTimedShuttleRoutesDefinitions(): RouteObject[] {
  return [
    {
      index: true,
      element: <RouteTimedShuttleMapBuilder />,
    },
    // Future: add more child routes here
  ];
}
